export default __webpack_public_path__ + "static/media/youtube.0dbbe81c.png";